import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
import { GridPattern } from '../graphics/GridPattern';
import { useLang } from '../../lib/i18n/LanguageContext';
import { dictionary } from '../../lib/i18n/dictionary';
import { useScheduleCall } from '../ScheduleCallModal';
export function FinalCTA() {
  const {
    lang
  } = useLang();
  const t = dictionary.finalCta;
  const hero = dictionary.hero;
  const {
    open
  } = useScheduleCall();
  return <section id="access" className="relative py-24 md:py-32 bg-white overflow-hidden" data-id="element-350">
      <GridPattern className="absolute inset-0 text-navy-deep opacity-[0.04]" data-id="element-351" />

      <div className="relative max-w-4xl mx-auto px-5 md:px-8 text-center" data-id="element-352">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} data-id="element-353">
          <div className="inline-flex items-center gap-2 mb-5" data-id="element-354">
            <span className="h-px w-8 bg-gold" data-id="element-355" />
            <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-gold-deep" data-id="element-356">
              {t.eyebrow[lang]}
            </span>
            <span className="h-px w-8 bg-gold" data-id="element-357" />
          </div>
          <h2 className="font-serif text-3xl md:text-5xl leading-[1.05] tracking-tight text-navy-deep" data-id="element-358">
            {t.title[lang]}
          </h2>
          <div className="mt-10 flex flex-col sm:flex-row justify-center gap-3" data-id="element-359">
            <a href="#supplier-form" data-id="element-360">
              <Button variant="gold" size="lg" data-id="element-361">
                {hero.ctaSupplier[lang]}
              </Button>
            </a>
            <a href="#buyer-form" data-id="element-362">
              <Button size="lg" className="bg-navy-deep text-white border-navy-deep hover:bg-navy-800" data-id="element-363">
                {hero.ctaBuyer[lang]}
              </Button>
            </a>
            <Button variant="ghost" size="lg" onClick={open} data-id="element-364">
              {t.privateCall[lang]}
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}